@import '../general';
@import 'sidenavi';

.cmp-sidenavi {
  a {
    @extend .elm-link;
  }

  db-icon {
    margin-right: #{to-rem(6)};
  }
}
